import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { env } from '../env';
import Typography from "@mui/material/Typography";
import { Box, CardActionArea, Skeleton } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

function EarlyDate({ page, setPage, data }) {
  const [earlyDate, setEarlyDate] = useState(null);
  const [earlyDateTo, setEarlyDateTo] = useState(null);
  const [loading, setLoading] = useState(false);
  const today = new Date().toLocaleString();

    useEffect(() => {
        const request = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            mode: "cors",
            body: JSON.stringify({
                LK: env.REACT_APP_LICENCE_KEY,
                ENVID: env.REACT_APP_ENV_ID,
                PlaceID: page.place.ID,
                AppointmentTypeID: page.motif.ID,
                PractitionerID: data.ID,
                From: today
            })
        };
    fetch(
      `${env.REACT_APP_PROXY_BASE_URL}/practitioner/schedule/next`, request
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.Schedule === undefined) {
          setEarlyDate(undefined);
          setEarlyDateTo(undefined);
        } else {
          setEarlyDate(res.Schedule.From);
          setEarlyDateTo(res.Schedule.To);
        }
      })
      .catch((err) => console.log("Early date fetch error " + err));
  }, []);

  const earlyTime = (dateToParse) => {
    const dateString = new Date(dateToParse).toLocaleDateString();
    const dayToday = new Date().toLocaleDateString();
    if (dateString === dayToday) {
      return `${moment(dateToParse).format("[Aujourd'hui] [à] HH:mm")}`;
    }
    return `${moment(dateToParse).format("[Le] dddd DD/MM/yyy [à] HH:mm")}`;
  };

  const handleClick = () => {
    setPage({
      ...page,
      page: 4,
      praticien: data,
      date: earlyDate,
      dateTo: earlyDateTo,
    });
  };

  return (
    <Box my={1} style={{ cursor: "pointer" }}>
      <CardActionArea
        onClick={(event) => {
          if (earlyDate) {
            handleClick();
          }
        }}
      >
        <Card sx={{ "&:hover": { boxShadow: 4 } }}>
          <CardContent>
            {loading && <Skeleton width={200} height={40} />}
            {earlyDate ? (
              <Typography>Au plus tôt : {earlyTime(earlyDate)}</Typography>
            ) : (
              <Typography>Pas de rendez-vous disponnible.</Typography>
            )}
          </CardContent>
        </Card>
      </CardActionArea>
    </Box>
  );
}

export default EarlyDate;
